const PUSH_LEFT_ANIMATIONS = ['content-push-left-out', 'content-push-left-in']
// Keyframe names used by animate-content-dissolve-in / animate-content-dissolve-out (crossfade)
const CROSSFADE_ANIMATIONS = ['fade-in', 'fade-out']
// Only elements with these classes count as the crossfade transition (avoids generic fade-in/fade-out from descendants)
const CROSSFADE_ANIMATION_CLASSES = ['animate-content-dissolve-in', 'animate-content-dissolve-out']
const ANIMATION_END_EVENTS = ['animationend', 'webkitAnimationEnd']
// Fallback if animationend never fires (e.g. some iOS Safari); step animations are 400ms
const FALLBACK_MS = 600

export const StepTransition = {
  mounted() {
    this._transitionHandled = false

    this._completeTransition = () => {
      if (this._transitionHandled) return
      this._transitionHandled = true
      if (this._fallbackTimeoutId != null) {
        clearTimeout(this._fallbackTimeoutId)
        this._fallbackTimeoutId = null
      }
      const transitionTo = this.el.dataset.transitionTo
      if (transitionTo) {
        this.pushEvent('complete-step-transition', { step: transitionTo })
      }
    }

    this._onAnimationEnd = event => {
      const transitionTo = this.el.dataset.transitionTo
      const transitionType = this.el.dataset.transitionType

      if (transitionTo) {
        const isPushLeft = transitionType === 'push-left'
        const isPushLeftAnimation = isPushLeft && PUSH_LEFT_ANIMATIONS.includes(event.animationName)
        const isDirectChild =
          event.target === this.el || Array.from(this.el.children).includes(event.target)
        const isContentDissolveTarget = CROSSFADE_ANIMATION_CLASSES.some(cls =>
          event.target.classList?.contains(cls),
        )
        const isCrossfade =
          !isPushLeft &&
          CROSSFADE_ANIMATIONS.includes(event.animationName) &&
          isDirectChild &&
          isContentDissolveTarget

        if (isPushLeftAnimation || isCrossfade) {
          this._completeTransition()
        }
      }
    }

    ANIMATION_END_EVENTS.forEach(name => this.el.addEventListener(name, this._onAnimationEnd))

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion) {
      requestAnimationFrame(() => this._completeTransition())
    } else {
      this._fallbackTimeoutId = setTimeout(() => this._completeTransition(), FALLBACK_MS)
    }
  },
  destroyed() {
    ANIMATION_END_EVENTS.forEach(name => this.el.removeEventListener(name, this._onAnimationEnd))
    if (this._fallbackTimeoutId != null) clearTimeout(this._fallbackTimeoutId)
  },
}
